import { useSearchParams } from "react-router-dom";
import BreadcrumbComponent from "../../../../../common/components/breadcrumb/BreadcrumbComponent";
import { Layout, Tabs } from "antd";
import MenuWrapperComponent from "../../../../../common/components/menu-wrapper";
import FilterComponent from "../component/filter";
import COMMON from "../../../../../common/constants/COMMON";
import { CCUS061Handler } from "../handler/HandlerImpl";
import TableCCUS from "./Table";
import { useEffect } from "react";
import { MENU_ITEM, PARAMS } from "../../constants";
import HomeSvg from "../../../../../assets/icons/home.svg";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../store";
import DetailCCUS061Modal from "../../../../../common/components/modal-detail-ccus061/DetailCCUS061Modal";

interface props {
  handler: CCUS061Handler;
}
const { Content, Sider } = Layout;
const { TabPane } = Tabs;

const BREADCRUMB_CCUS061: any[] = [
  {
    title: "建設キャリアアップシステム",
    url: "",
    icon: (
      <img style={{ paddingBottom: 2, paddingRight: 8 }} alt="" src={HomeSvg} />
    ),
  },
  {
    title: "技能者情報閲覧",
    url: "",
    icon: "",
  },
];

const MainUI = ({ handler }: props) => {
  const [searchParams] = useSearchParams();

  const isOpenDetailCCUS061Modal = useSelector(
    (state: RootState) => state.ccus062.isOpenModalCcus061
  );

  const page = searchParams.get(PARAMS.page) || COMMON.DEFAULT_PAGE + "";
  const size = searchParams.get(PARAMS.size) || COMMON.DEFAULT_SIZE + "";

  const userId = searchParams.get(PARAMS.userId) || "";
  const groupId = searchParams.get(PARAMS.groupId) || "";
  const sortType = searchParams.get(PARAMS.sortType);
  const sortBy = searchParams.get(PARAMS.sortBy);
  const lastReferred = searchParams.get("lastReferred") === "true";

  useEffect(() => {
    if (handler.state !== MENU_ITEM[0].code) return;

    const params: any = {
      page: +page,
      size: +size,
    };
    if (userId) params.userId = +userId;
    if (groupId) params.groupId = +groupId;
    if (sortType) params.sortType = sortType;
    if (sortBy) params.sortBy = sortBy;
    handler.getListEmployeeVerification(params);
  }, [handler.state, page, size, userId, groupId, sortBy, sortType]);

  // Tab 技能者認証 không còn bộ lọc nên không có nút 検索 để kích hoạt fetch:
  // vào tab là gọi API luôn. isRefresh đổi sau khi submit thành công -> tự tải lại.
  useEffect(() => {
    if (handler.state !== MENU_ITEM[1].code) return;

    handler.getListCompanyEmployee({ lastReferred });
  }, [handler.state, lastReferred, handler.isRefresh]);

  return (
    <>
      <MenuWrapperComponent chosenKey={94} openKey={9}>
        <div>
          <div className="om002-header-container">
            <BreadcrumbComponent data={BREADCRUMB_CCUS061} />

            <div className="header-row-title-ccus02">技能者情報閲覧</div>
          </div>

          <div className="ccus061-body">
            <Tabs
              type="card"
              activeKey={handler.state}
              onChange={handler.handleChangeMenuChosen}
              destroyInactiveTabPane
            >
              <TabPane tab={MENU_ITEM[0].name} key={MENU_ITEM[0].code}>
                <Layout
                  style={{ minHeight: "80vh" }}
                  className="open-side-ccus06"
                >
                  <Sider>
                    <FilterComponent />
                  </Sider>
                  <Layout className="bg-fff">
                    <Content className="content-table-ccus06">
                      <TableCCUS handler={handler} />
                    </Content>
                  </Layout>
                </Layout>
              </TabPane>

              <TabPane tab={MENU_ITEM[1].name} key={MENU_ITEM[1].code}>
                <Layout style={{ minHeight: "80vh" }} className="bg-fff">
                  <Content className="content-table-ccus06 ccus061-content-full">
                    <TableCCUS handler={handler} />
                  </Content>
                </Layout>
              </TabPane>
            </Tabs>
          </div>
        </div>
        {isOpenDetailCCUS061Modal ? <DetailCCUS061Modal /> : <></>}
      </MenuWrapperComponent>
    </>
  );
};

export default MainUI;
